// extracted by mini-css-extract-plugin
module.exports = {"Form":"EditingForm_Form__310M2","Fieldset":"EditingForm_Fieldset__N-z8R","Save":"EditingForm_Save__1eLSA"};